//配置全局访问接口地址
//let imaUrl = "https://qcban.aixuetang.com/res"; //线上地址
//const futureImgUrl = "http://192.168.0.52:9880/jsznjypt/res";//测试地址
let configUrl = {}
if (process.env.NODE_ENV === 'testing') {
  configUrl = {
    futureImgUrl: 'http://192.168.0.52:9880/jsznjypt/res',
    teacherPath:'http://192.168.0.52:9880/jsznjypt',
    stuPath:'http://192.168.0.47:10011',
    lsPath:'http://www.aixueyun.cn/pic'
  }
}
if (process.env.NODE_ENV === 'development') {
  configUrl = {
    futureImgUrl: 'http://192.168.0.52:9880/jsznjypt/res',
    teacherPath:'http://192.168.0.52:9880/jsznjypt',
    stuPath:'http://192.168.0.47:10011',
    lsPath:'http://www.aixueyun.cn/pic'
  }
}
if (process.env.NODE_ENV === 'production') {
  configUrl = {
    futureImgUrl: 'https://qcban.aixuetang.com/res',
    teacherPath: 'https://js.aixuetang.com',
    stuPath:'https://www.aixuetang.com',
    lsPath:'http://www.aixueyun.cn/pic'
  }
}
export default configUrl



// WEBPACK FOOTER //
// ./src/interface/index.js